<template>
    <div class="flex items-center"
         :class="[showItemCounter ? 'flex-col md:flex-row md:justify-between' : ' justify-center md:justify-end', padding > 0 ?  ('p-' + padding) : '']">

        <!-- Displaying x to x of x items -->
        <div v-if="showItemCounter" class="text-gray-600">
            Displaying {{ meta.from ? meta.from : 0 }} to {{ meta.to ? meta.to : 0 }} of {{ meta.total ? meta.total : 0 }} items
        </div>

        <!-- Pager navigation -->
        <div class="flex items-center text-gray-400" :class="[showItemCounter ? 'mt-2 md:mt-0' : '']">
            <!-- First arrow button -->
            <button @click="goToPage(1)" class="outline-none px-1"
                    :class="meta.current_page === 1 ? '' : 'hover:text-gray-600'" :disabled="meta.current_page === 1">
                <svg class="w-5 h-5" viewBox="0 0 24 24" stroke="currentColor" fill="none">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 19l-7-7 7-7m8 14l-7-7 7-7"></path>
                </svg>
            </button>

            <!-- Previous arrow button -->
            <button @click="goToPage(meta.current_page - 1)" class="text-center outline-none px-1"
                    :class="meta.current_page === 1 ? '' : 'hover:text-gray-600'" :disabled="meta.current_page === 1">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
                </svg>
            </button>

            <!-- x Previous numbers -->
            <button v-for="previousPage in previousPages" @click="goToPage(previousPage)" class="text-center hover:text-gray-600 outline-none px-2">
                {{ previousPage }}
            </button>

            <!-- Current page / page input -->
            <input class="text-center text-gray-600 bg-white border border-gray-300 rounded-sm w-7 h-5 px-0 outline-none mx-1"
                   type="text"
                   v-model="inputPage"
                   @keyup.enter="goToPage(inputPage)"/>

            <!-- x Next numbers -->
            <button v-for="nextPage in nextPages" @click="goToPage(nextPage)" class="text-center hover:text-gray-600 outline-none px-2 ">
                {{ nextPage }}
            </button>

            <!-- Next arrow button -->
            <button @click="goToPage(meta.current_page + 1)" class="text-center outline-none px-1"
                    :class="meta.current_page === meta.last_page ? '' : 'hover:text-gray-600'" :disabled="meta.current_page === meta.last_page">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                </svg>
            </button>

            <!-- Last arrow button -->
            <button @click="goToPage(meta.last_page)" class="text-center outline-none px-1"
                    :class="meta.current_page === meta.last_page ? '' : 'hover:text-gray-600'" :disabled="meta.current_page === meta.last_page">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5l7 7-7 7M5 5l7 7-7 7"></path>
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "SimplePagination",

    props: {
        meta: {
            required: true,
            description: "The meta data of the pagination result",
        },

        perPage: {
            required: false,
            default: 10,
            description: "The number of items per page",
        },

        sideNavigationCount: {
            required: false,
            default: 2,
            description: "The count of previous or next page numbers on the side of the input box",
        },

        showItemCounter: {
            required: false,
            default: true,
            description: "Shows the 'Displaying x to x of x items' display",
        },

        padding: {
            required: false,
            default: 0,
            description: "Padding for the component"
        },
    },

    data () {
        return {
            inputPage: 1,
        };
    },

    mounted () {
        this.setCurrentPageFromMetaInfo();
    },

    watch: {
        "meta": {
            handler: function () {
                this.setCurrentPageFromMetaInfo();
            },
            deep: true
        }
    },

    computed: {
        previousPages () {
            let previousPages = [];

            let counter;
            for (counter = 1; counter <= this.sideNavigationCount; counter++) {
                let number = this.meta.current_page - counter;
                if (number >= 1) {
                    previousPages.unshift(number);
                }
            }
            return previousPages;
        },

        nextPages () {
            let nextPages = [];

            let counter;
            for (counter = 1; counter <= this.sideNavigationCount; counter++) {
                let number = this.meta.current_page + counter;
                if (number <= (this.meta.last_page)) {
                    nextPages.push(number);
                }
            }

            return nextPages;
        },
    },

    methods: {
        setCurrentPageFromMetaInfo () {
            if (this.meta && this.meta.current_page) {
                this.inputPage = this.meta.current_page;
            } else {
                this.inputPage = 1;
            }
        },

        goToPage (page) {
            let pageNumber = parseInt(page);
            // Only navigate if page is in range of 1 to last_page
            if (pageNumber !== this.meta.current_page) {
                if (pageNumber >= 1 && pageNumber <= this.meta.last_page) {
                    this.$emit("page-changed", {"pageNumber": pageNumber, "perPage": this.perPage});
                } else {
                    toastr.error("Page does not exist");
                    this.inputPage = this.meta.current_page;
                }
            }
        },
    },
};
</script>

<style scoped>

</style>
